import React from 'react';
import AsyncImpressions from './impressions/async';
import AsyncOverview from './overview/async';
import AsyncSessions from './sessions/async';
import AsyncSkuPreferences from './skupreferences/async';
import AsyncUserEngagement from './userengagement/async';
import AsyncUniqueUsers from './uniqueusers/async';
import AsyncDetections from './detections/async';
import AsyncSimulations from './simulations/async';
import AsyncClientBase from './clientbase/async';
import AsyncDemographics from './demographics/async';
import AsyncScores from './scores/async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';
import _get from 'lodash/get';
import subscriptionUtils from '../../../utils/subscriptionUtils';
import smbUtils from '../../../utils/smbUtils';
import {
  multipleSubscriptionsUtils,
  solutionUtils,
} from '../../../utils/solutionUtils';

const parents = [
  {
    title: <Trans i18nKey="p.w.reports.title">Analytics</Trans>,
    path: '/web-module/reports/overview',
  },
];

export default function Reports(accountSummary) {
  const functionType = _get(accountSummary, 'customer.functionType');
  const isSkincareAboveV2 = subscriptionUtils.isSkincareVersionAbove2(
    accountSummary
  );
  const isCnSite = smbUtils.isCnSite(accountSummary);
  const isUuVersion = subscriptionUtils.isUniqueUsersVersion(accountSummary);
  const isOwner = subscriptionUtils.isOwnerRole(accountSummary);

  const getReportPages = () => {
    switch (functionType) {
      case 'SKINCARE_PRO':
        const isSkinAnalysis = solutionUtils.isSkinAnalysis(accountSummary);
        const isSimulation = solutionUtils.isSimulation(accountSummary);
        const overdueSolutions = multipleSubscriptionsUtils.overdueSolutions(
          accountSummary
        );
        const isSkinAnalysisOverdue = overdueSolutions.includes(
          'SKIN_ANALYSIS'
        );
        const isSimulationOverdue = overdueSolutions.includes(
          'AESTHETIC_SIMULATION'
        );
        const showAnalysisDetection =
          isSkinAnalysis || (isOwner && isSkinAnalysisOverdue);
        const showSimulationDetection =
          isSimulation || (isOwner && isSimulationOverdue);
        const showClientOverview =
          isSkincareAboveV2 &&
          !isCnSite &&
          (showAnalysisDetection || showSimulationDetection);

        let analysisPage = [
          <SingleColumnLayout
            exact
            key="a"
            path="/web-module/reports/overview"
            component={AsyncOverview}
            title={
              <div className="tutorial-analytics">
                <Trans i18nKey="p.w.r.overview.title">Overview</Trans>
              </div>
            }
            parents={parents}
          />,
        ];

        if (showAnalysisDetection) {
          analysisPage.push(
            <SingleColumnLayout
              exact
              key="b"
              path="/web-module/reports/detections"
              component={AsyncDetections}
              title={<Trans i18nKey="p.w.r.detections.title">Detections</Trans>}
              parents={parents}
            />
          );
        }

        if (showSimulationDetection) {
          analysisPage.push(
            <SingleColumnLayout
              exact
              key="c"
              path="/web-module/reports/simulations"
              component={AsyncSimulations}
              title={
                <Trans i18nKey="p.w.r.simulations.title">Simulations</Trans>
              }
              parents={parents}
            />
          );
        }

        if (showClientOverview) {
          analysisPage = analysisPage.concat([
            <SingleColumnLayout
              exact
              key="d"
              path="/web-module/reports/client"
              component={AsyncClientBase}
              title={<Trans i18nKey="p.w.r.client.title">Client</Trans>}
              parents={parents}
            />,
            <SingleColumnLayout
              exact
              key="e"
              path="/web-module/reports/demographics"
              component={AsyncDemographics}
              title={
                <Trans i18nKey="p.w.r.demographics.title">Demographics</Trans>
              }
              parents={parents}
            />,
            <SingleColumnLayout
              exact
              key="e"
              path="/web-module/reports/scores"
              component={AsyncScores}
              title={<Trans i18nKey="p.w.r.scores.title">Scores</Trans>}
              parents={parents}
            />,
          ]);
        }

        return analysisPage;
      case 'EYEWEAR':
        const defaultReportPages = [
          <SingleColumnLayout
            exact
            key="a"
            path="/web-module/reports/impressions"
            component={AsyncImpressions}
            title={<Trans i18nKey="p.w.r.impressions.title">Impressions</Trans>}
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="b"
            path="/web-module/reports/overview"
            component={AsyncOverview}
            title={
              <div className="tutorial-analytics">
                <Trans i18nKey="p.w.r.overview.title">Overview</Trans>
              </div>
            }
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="c"
            path="/web-module/reports/sessions"
            component={AsyncSessions}
            title={<Trans i18nKey="p.w.r.sessions.title">Sessions</Trans>}
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="d"
            path="/web-module/reports/user-engagement"
            component={AsyncUserEngagement}
            title={
              <Trans i18nKey="p.w.r.user.engagement.title">
                User Engagement
              </Trans>
            }
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="e"
            path="/web-module/reports/sku-preferences"
            component={AsyncSkuPreferences}
            title={
              <Trans i18nKey="p.w.r.sku.preferences.title">
                SKU Preferences
              </Trans>
            }
            parents={parents}
          />,
        ];

        if (isUuVersion) {
          return defaultReportPages.concat([
            <SingleColumnLayout
              exact
              key="f"
              path="/web-module/reports/unique-users"
              component={AsyncUniqueUsers}
              title={
                <div className="tutorial-analytics">
                  <Trans i18nKey="p.w.r.uniqueusers.title">Unique Users</Trans>
                </div>
              }
              parents={parents}
            />,
          ]);
        }
        return defaultReportPages;
      default:
        return [
          <SingleColumnLayout
            exact
            key="a"
            path="/web-module/reports/impressions"
            component={AsyncImpressions}
            title={<Trans i18nKey="p.w.r.impressions.title">Impressions</Trans>}
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="b"
            path="/web-module/reports/overview"
            component={AsyncOverview}
            title={
              <div className="tutorial-analytics">
                <Trans i18nKey="p.w.r.overview.title">Overview</Trans>
              </div>
            }
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="c"
            path="/web-module/reports/sessions"
            component={AsyncSessions}
            title={<Trans i18nKey="p.w.r.sessions.title">Sessions</Trans>}
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="d"
            path="/web-module/reports/user-engagement"
            component={AsyncUserEngagement}
            title={
              <Trans i18nKey="p.w.r.user.engagement.title">
                User Engagement
              </Trans>
            }
            parents={parents}
          />,
          <SingleColumnLayout
            exact
            key="e"
            path="/web-module/reports/sku-preferences"
            component={AsyncSkuPreferences}
            title={
              <Trans i18nKey="p.w.r.sku.preferences.title">
                SKU Preferences
              </Trans>
            }
            parents={parents}
          />,
        ];
    }
  };

  const getReportRedirect = () => {
    switch (functionType) {
      case 'SKINCARE_PRO':
        return [
          <Redirect
            key="i"
            exact
            from="/web-module/reports/impressions"
            to="/web-module/reports/overview"
          />,
          <Redirect
            key="j"
            exact
            from="/web-module/reports/sessions"
            to="/web-module/reports/overview"
          />,
          <Redirect
            key="k"
            exact
            from="/web-module/reports/user-engagement"
            to="/web-module/reports/overview"
          />,
          <Redirect
            key="l"
            exact
            from="/web-module/reports/sku-preferences"
            to="/web-module/reports/overview"
          />,
          <Redirect
            key="n"
            exact
            from="/web-module/reports/get-report"
            to="/web-module/reports/overview"
          />,
          <Redirect
            key="o"
            exact
            from="/web-module/reports"
            to="/web-module/reports/overview"
          />,
        ];
      default:
        return [
          <Redirect
            key="h"
            exact
            from="/web-module/reports"
            to="/web-module/reports/overview"
          />,
        ];
    }
  };

  return getReportPages().concat(getReportRedirect());
}
